import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('prasha_token'));
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
    } catch {
      localStorage.removeItem('prasha_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = (newToken, userData) => {
    localStorage.setItem('prasha_token', newToken);
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('prasha_token');
    setToken(null);
    setUser(null);
  };

  const api = axios.create({ baseURL: API });
  api.interceptors.request.use((config) => {
    const t = localStorage.getItem('prasha_token');
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
  });

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, api, API }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
